import { FaGraduationCap } from "react-icons/fa";
import "./TrainingProgramsSection.css";

const programsData = [
  {
    id: "dao-tao-chuyen-nghiep",
    title: "ĐÀO TẠO CHUYÊN NGHIỆP",
    image: "/images/home/programs/program1.webp",
  },
  {
    id: "dao-tao-trung-cap",
    title: "ĐÀO TẠO TRUNG CẤP",
    image: "/images/home/programs/program2.webp",
  },
  {
    id: "lien-ket-quoc-te",
    title: "LIÊN KẾT QUỐC TẾ",
    image: "/images/home/programs/program3.webp",
  },
  {
    id: "dao-tao-tu-xa",
    title: "ĐÀO TẠO TỪ XA",
    image: "/images/home/programs/program4.webp",
  },
];

const TrainingProgramsSection = () => {
  return (
    <section className="programs">
      <div className="programs__container">
        {/* Icon */}
        <div className="programs__icon">
          <FaGraduationCap />
        </div>

        {/* Title */}
        <h2 className="programs__title">HỆ ĐÀO TẠO</h2>

        {/* Cards */}
        <div className="programs__cards">
          {programsData.map((program) => (
            <div
              key={program.id}
              id={program.id} // giúp anchor, scroll, navlink...
              className="program-card"
            >
              <div className="program-card__image">
                <img
                  src={program.image}
                  alt={program.title}
                  loading="lazy"
                />
              </div>
              <h3 className="program-card__title">{program.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrainingProgramsSection;
